import MiButton from './mi-button.vue'
export default MiButton
